





















































































































































































































































































































































































































/* eslint-disable */
import { Component, Vue } from "vue-property-decorator";

import MediaSelect from "@/components/MediaSelect.vue";
import TimeSlotPicker from "@/components/TimeSlotPicker.vue";
import VNumberPicker from "@/components/VNumberPicker.vue";
import TimePicker from "@/components/TimePicker.vue";
import MultiLevelObject from "@/interfaces/MultiLevelObject";
import MultiLevelSelect from "@/components/MultiLevelSelect.vue";
import VSwitchButton from "@/components/VSwitchButton.vue";
import VCheckButton from "@/components/VCheckButton.vue";
import VCheckButtonRadio, {
  VCheckButtonRadioOptions,
} from "@/components/VCheckButtonRadio.vue";
import DatePicker from "@/components/DatePicker.vue";
import ComparisonGroupSelect from "@/components/ComparisonGroupSelect.vue";
import EntrySearch from "@/components/EntrySearch.vue";
import EntrySelect from "@/components/EntrySelect.vue";
import FeatureSelect from "@/components/FeatureSelect.vue";
import { Company, Brand, Product } from "../../models";
import VAudio from "@/components/VAudio.vue";
import VVideo from "@/components/VVideo.vue";
import VModalVideo from "@/components/VModalVideo.vue";
import {
  WeekPickerModality,
  WeekPickerResult,
  WEEK_PICKER_MODALITY_DATE_RANGE,
  WEEK_PICKER_MODALITY_WEEK_RANGE,
} from "@/interfaces/WeekPickerDataTypes";
import VWeekPicker from "@/components/VWeekPicker.vue";
import * as moment from "moment";
import AdminCompanySelect from "@/components/AdminCompanySelect.vue";
import TwoStagesSelect, {
  TwoStagesModel,
} from "@/components/TwoStagesSelect.vue";
import SpecialInitiativesSubjectSelector, {
  SubjectKind,
} from "@/components/SpecialInitiatives/SpecialInitiativesSubjectSelector.vue";

@Component({
  components: {
    MediaSelect,
    VNumberPicker,
    TimePicker,
    TimeSlotPicker,
    MultiLevelSelect,
    VSwitchButton,
    VCheckButton,
    VCheckButtonRadio,
    DatePicker,
    ComparisonGroupSelect,
    EntrySearch,
    EntrySelect,
    FeatureSelect,
    VAudio,
    VVideo,
    VModalVideo,
    VWeekPicker,
    AdminCompanySelect,
    TwoStagesSelect,
    SpecialInitiativesSubjectSelector,
  },
})
export default class CustomControls extends Vue {
  media = {
    radio: true,
    tv: false,
  };

  number = 0;
  time = "10:30";
  timeSlots = [];
  option = null;
  switchValue = true;
  checkValue = false;
  dateRange = null;
  dateRangeWithCompare = null;

  options: Array<MultiLevelObject> = [
    {
      id: "1",
      text: "First",
    },
    {
      id: "2",
      text: "Second",
      children: [
        {
          id: "2.1",
          text: "Second Children 1",
        },
        {
          id: "2.2",
          text: "Second Children 2",
        },
        {
          id: "2.3",
          text: "Second Children 3",
          children: [
            {
              id: "2.3.1",
              text: "Second Nephew 1",
            },
            {
              id: "2.3.2",
              text: "Second Nephew 2",
            },
          ],
        },
      ],
    },
    {
      id: "3",
      text: "Third",
    },
  ];

  headers = ["Level 1", "Level 2", "Level 3"];

  entries = {};

  entry: Company | Brand | Product | null = null;

  radioValue = "never";

  radioOptions: VCheckButtonRadioOptions = {
    never: "Mai",
    daily: "Quotidiano",
    weekly: "Settimanale",
  };

  features: string[] = [];

  onSearch(entries: any) {
    this.entries = entries;
  }

  openVideo(which: string) {
    const modalVideo = this.$refs[which] as any;
    modalVideo.show();
  }

  weekRange: WeekPickerResult = {
    type: WEEK_PICKER_MODALITY_WEEK_RANGE,
    end: {
      year: 2021,
      week: 1,
    },
    start: {
      year: 2010,
      week: 53,
    },
  };

  customCompany: Company | null = null;

  weekRange2: WeekPickerResult = {
    type: WEEK_PICKER_MODALITY_DATE_RANGE,
    end: this.$moment().toDate(),
    start: this.$moment().subtract(1, "month").toDate(),
  };
  weekModality: WeekPickerModality = WEEK_PICKER_MODALITY_DATE_RANGE;
  wpMinDate = this.$moment().startOf("year").toDate();
  wpMaxDate = this.$moment().endOf("year").toDate();

  tsModel: TwoStagesModel = {
    selectedGroupId: null,
    groups: [
      {
        id: "a",
        text: "First group",
        count: 0,
        items: [
          {
            id: "item_a",
            text: "First item",
            selected: false,
          },
          {
            id: "item_b",
            text: "Second item",
            selected: false,
          },
          {
            id: "item_c",
            text: "Third item",
            selected: false,
          },
          {
            id: "item_d",
            text: "Fourth item",
            selected: false,
          },
          {
            id: "item_e",
            text: "Fifth item",
            selected: false,
          },
        ],
      },
      {
        id: "b",
        text: "Second group",
        count: 0,
        items: [],
      },
      {
        id: "c",
        text: "Third group",
        count: 0,
        items: [],
      },
      {
        id: "4",
        text: "Fourth group",
        count: 0,
        items: [],
      },
      {
        id: "5",
        text: "Fifth group",
        count: 0,
        items: [],
      },
      {
        id: "6",
        text: "Sixth group",
        count: 0,
        items: [],
      },
      {
        id: "7",
        text: "Seventh group",
        count: 0,
        items: [],
      },
    ],
  };
  subjectKind: SubjectKind = null;
  onKindSelected(kind: SubjectKind) {
    this.subjectKind = kind;
  }
  selectedSubjects: string[] = [];
}
